<!-- @format -->
<template>
    <div>
        <div class="gst-booking-layout-group gst-booking-layout-group--background">
            <slot name="status"></slot>
            <slot name="order-number"></slot>
            <slot></slot>
        </div>
        <slot name="payment-summary"></slot>
        <slot name="cancellation-policy"></slot>
    </div>
</template>

<script>
export default {
    name: 'BookingLayout',
};
</script>
<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-booking-failed {
    .gst-booking-layout-group.gst-booking-layout-group--background {
        padding: theme-spacing(6);
        background-color: theme-color('quinary');
    }
}
</style>
